<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    label="IssueDate"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.required('Issue date')"
                  ></v-text-field>
                  <v-date-picker
                    v-model="issueDate"
                    :rules="rules.required('Issue date')"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productionCosting.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No"
                  type="text"
                  readonly
                  v-model="productionCosting.issueNo"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="productionCosting.shopId"
                  :items="shopList"
                  color="blue-grey lighten-2"
                  label="Choose Shop..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Shop')"
                  @change="clearOldProductionCostingDetail()"
                  :readonly="
                    status != 'DRAFT' || checkRoleShop() ? true : false
                  "
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="productionCosting.costingMonth"
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="productionCosting.costingMonth"
                      label="Month"
                      prepend-icon="event"
                      :disabled="status != 'DRAFT'"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="productionCosting.costingMonth"
                    type="month"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        $refs.menu.save(productionCosting.costingMonth),
                          clearOldProductionCostingDetail()
                      "
                      >Ok</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="productionCosting.manufacturingCostId"
                  :items="activeManufacturingCostList"
                  color="blue-grey lighten-2"
                  label="Choose Manufacturing Cost..."
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :hide-no-data="true"
                  :rules="rules.required('Manufacturing Cost')"
                  @change="clearOldProductionCostingDetail()"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12 v-if="productionCosting.id">
                <v-select
                  v-model="productionCosting.status"
                  :items="statusList"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  :rules="rules.required('Status')"
                  :readonly="status != 'DRAFT'"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="productionCosting.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productionCosting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productionCosting.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="productionCosting.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productionCosting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productionCosting.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="productionCosting.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-card>
                  <v-card-title>
                    <v-btn
                      color="success"
                      @click="onSearch()"
                      :disabled="status != 'DRAFT' || showListLoading"
                      :loading="showListLoading"
                    >
                      Search Detail
                      <v-icon right>add</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="productionCosting.productionCostingDetailList"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td>
                          <v-text-field
                            v-model="props.item.productCode"
                            type="text"
                            :rules="rules.lengthRequiredRules(20, 'Code')"
                            readonly
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.productName"
                            type="text"
                            :rules="rules.lengthRequiredRules(100, 'Name')"
                            readonly
                            style="width: 250px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-autocomplete
                            v-model="props.item.productionItemIds"
                            :items="props.item.productionItemList"
                            color="blue-grey lighten-2"
                            menu-props="auto"
                            item-text="name"
                            item-value="id"
                            multiple
                            chips
                            style="width: 220px"
                            readonly
                          ></v-autocomplete>
                        </td>
                        <td>
                          <v-autocomplete
                            v-model="props.item.productionOrderIds"
                            :items="props.item.productionOrderList"
                            color="blue-grey lighten-2"
                            menu-props="auto"
                            item-text="issueNo"
                            item-value="id"
                            multiple
                            chips
                            style="width: 220px"
                            readonly
                          ></v-autocomplete>
                        </td>
                        <td>
                          <v-autocomplete
                            v-model="props.item.productionHeaderIds"
                            :items="props.item.productionHeaderList"
                            color="blue-grey lighten-2"
                            menu-props="auto"
                            item-text="issueNo"
                            item-value="id"
                            :rules="rules.required('Production')"
                            multiple
                            chips
                            style="width: 220px"
                            readonly
                          ></v-autocomplete>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.productionQty"
                            type="number"
                            readonly
                            style="width: 150px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-autocomplete
                            :items="props.item.productUnits"
                            v-model="props.item.factorUnitName"
                            item-text="factorUnitName"
                            item-value="factorUnitName"
                            menu-props="auto"
                            color="blue-grey lighten-2"
                            :hide-no-data="true"
                            :rules="rules.required('Unit')"
                            readonly
                            style="width: 200px"
                          ></v-autocomplete>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.unitCost"
                            type="number"
                            :rules="rules.zeroUnitCostRules('Unit Cost')"
                            :readonly="status != 'DRAFT'"
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.actualQty"
                            type="number"
                            readonly
                            style="width: 150px"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="props.item.amount"
                            type="number"
                            @input="calculateUnitCost(props.item)"
                            :rules="rules.zeroUnitCostRules('Amount')"
                            :readonly="status != 'DRAFT'"
                            style="width: 200px"
                          ></v-text-field>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="clear"
                    :disabled="status != 'DRAFT'"
                  >
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading || status != 'DRAFT'"
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
  <script>
import { productionCostingService } from "../../services/production-costing-service";
import { shopService } from "../../services/shop-service";
import { commonService } from "../../services/common-service";
import { ProductionCosting } from "../../models/model";
import { ProductionCostingFormRules } from "../../helpers/validation-rules";
import { manufacturingCostService } from "../../services/manufacturing-cost-service";

export default {
  name: "ProductionCostingDetail",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    messageDialogBox: false,
    saveLoading: false,
    menu: false,
    clickOnSearch: false,
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Production Costing",
        disabled: false,
        to: "production-costings",
      },
      {
        text: "Production Costing Detail",
        disabled: true,
      },
    ],
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    headers: [
      { text: "Code", align: "left", sortable: false },
      { text: "Name", sortable: false },
      { text: "Production Item Type", sortable: false },
      { text: "Production Order No", sortable: false },
      { text: "Production Issue No", sortable: false },
      { text: "Production Qty", sortable: false },
      { text: "Unit", sortable: false },
      { text: "Unit Cost", sortable: false },
      { text: "Actual Qty", sortable: false },
      { text: "Amount", sortable: false },
    ],
    productionCosting: new ProductionCosting(),
    oldProductionCosting: new ProductionCosting(),
    rules: new ProductionCostingFormRules(),
    issueDate: "",
    createdDate: "",
    updatedDate: "",
    status: "DRAFT",
    responseError: "",
    activeManufacturingCostList: [],
    shopList: [],
  }),
  created() {
    this.getAllShopList();
    this.getActiveManufacturingCostList();

    this.productionCosting.shopId = this.checkRoleShop();

    const id = this.$route.params.id;
    if (id == "new") {
      this.issueDate = commonService.formatDate(new Date(), "YYYY-MM-DD");
      this.productionCosting.costingMonth = new Date()
        .toISOString()
        .substring(0, 7);
    } else {
      this.getProductionCostingDetail(id);
    }
  },
  methods: {
    checkRoleShop() {
      if (
        this.user.roleName == "BRANCH_ADMIN" ||
        this.user.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    getAllShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveManufacturingCostList() {
      manufacturingCostService
        .getManufacturingCostByStatus("ACTIVE")
        .then((res) => {
          this.activeManufacturingCostList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      if (this.$refs.form.validate()) {
        this.clickOnSearch = true;
        if (this.productionCosting.id) {
          this.productionCosting.productionCostingDetailList.forEach(
            (pcCosting) => {
              if (!this.productionCosting.deleteProductionCostingDetailIds) {
                this.productionCosting.deleteProductionCostingDetailIds = [];
              }
              this.productionCosting.deleteProductionCostingDetailIds.push(
                pcCosting.id
              );
            }
          );
        }
        this.productionCosting.productionCostingDetailList = [];
        this.getProductionCostingDetailList();
      }
    },
    getProductionCostingDetailList() {
      this.showListLoading = true;
      let params = {
        shopId: this.productionCosting.shopId,
        costingMonth: this.productionCosting.costingMonth,
        manufacturingCostId: this.productionCosting.manufacturingCostId,
      };
      productionCostingService
        .searchProductionCostingDetailList(params)
        .then((res) => {
          if (res.data) {
            this.productionCosting.productionCostingDetailList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
          }
          this.showListLoading = false;
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    calculateUnitCost(productionCostingDetail) {
      productionCostingDetail.unitCost = parseFloat(
        (
          productionCostingDetail.amount / productionCostingDetail.actualQty
        ).toFixed(6)
      );
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          if (this.productionCosting.productionCostingDetailList.length != 0) {
            this.saveLoading = true;
            this.productionCosting.issueDateInMilliSeconds =
              commonService.convertToMilliseconds(this.issueDate);
            productionCostingService
              .saveProductionCosting(this.productionCosting)
              .then((res) => {
                if (res) {
                  this.goBack();
                }
              })
              .catch((err) => {
                console.log(err);
                if (err.response.data) {
                  this.responseError = err.response.data.message;
                  this.messageDialogBox = true;
                }
                this.saveLoading = false;
              });
          } else {
            this.messageDialogBox = true;
            this.responseError = "Please Click the Search Button First.";
          }
        }
      }
    },
    getProductionCostingDetail(id) {
      productionCostingService
        .getProductionCostingDetail(id)
        .then((res) => {
          this.productionCosting = res.data;
          this.status = this.productionCosting.status;
          this.issueDate = commonService.millisecondToDate(
            this.productionCosting.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.createdDate = commonService.millisecondToDate(
            this.productionCosting.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.productionCosting.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );

          //deep copy
          this.oldProductionCosting = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clearOldProductionCostingDetail() {
      if (this.productionCosting.id) {
        this.productionCosting.productionCostingDetailList.forEach(
          (pcCosting) => {
            if (!this.productionCosting.deleteProductionCostingDetailIds) {
              this.productionCosting.deleteProductionCostingDetailIds = [];
            }
            this.productionCosting.deleteProductionCostingDetailIds.push(
              pcCosting.id
            );
          }
        );
      }
      this.productionCosting.productionCostingDetailList = [];
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.productionCosting.id) {
        this.productionCosting = new ProductionCosting();
      } else {
        this.productionCosting = Object.assign({}, this.oldProductionCosting);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
  